import { AppError } from "./index";

/**
 * Custom error to encapsulate HTTP bad request error.
 */
export class BadRequestError extends AppError {
  /**
   * Bad request error class constructor.
   *
   * @param {string} errorKey      A unique key that identifies the error.
   * @param {string} errorMessage  Description of the error.
   * @param {Error}  originalError Axios response error object.
   */
  constructor(errorKey, errorMessage, originalError, statusCode) {
    super(originalError);

    this.errorMessage = errorMessage;
    this.errorKey = errorKey;
    this.statusCode = statusCode;
  }
}
